<script setup lang="ts">
defineProps({
  isHorizontalList: {
    type: Boolean,
    default: false,
  },
  alwaysWrap: {
    type: Boolean,
    default: false,
  },
})
</script>

<template>
  <div
    class="loading-list flex flex-wrap w-full"
    :class="{
      'loading-list--horizontal': isHorizontalList,
    }"
  >
    <div
      v-for="item in isHorizontalList ? 4 : 16"
      :key="`loading-card-${item}`"
      class="loading-card loading-effect flex flex-col"
      :class="{
        'loading-list--always-wrap': alwaysWrap,
      }"
    />
  </div>
</template>

<style lang="postcss" scoped>
@import '~/assets/css/loading.css';

.loading-list {
  display: flex;
  gap: 1rem;
}

.loading-list--horizontal {
  .loading-card {
    display: none;

    &:nth-child(1),
    &:nth-child(2) {
      display: flex;
    }

    @media (min-width: 768px) {
      display: flex;
    }
  }
}

.loading-card {
  width: 100%;
  height: 146px;

  .loading-list--horizontal & {
    height: 204px;
    width: calc(50% - 0.5rem);
  }

  &:not(.loading-list--always-wrap) {
    @media (min-width: 768px) {
      /*
      4 columns
      0.5rem gap between
    */
      flex: 1 1 calc((100% - (3 * 1rem)) / 4);
      max-width: calc((100% - (3 * 1rem)) / 4);
      height: 344px !important;
    }
  }
}
</style>
